import { post, get } from './client';

export interface ScanLoginScene {
  sceneKey: string;
  status: 'pending' | 'scanned' | 'confirmed' | 'cancelled' | 'expired';
  expireAt: string;
  scannedBy?: string;
  scannedAt?: string;
  confirmedAt?: string;
  deviceInfo?: string;
  clientIp?: string;
}

/**
 * 轮询结果。refreshToken 不在其中——后端 pollScanLoginScene 会先把它从
 * 响应体删除，再经 deliverRefreshToken 写入 HttpOnly Cookie。
 */
export interface ScanLoginPollResult extends ScanLoginScene {
  accessToken?: string;
}

/**
 * 创建扫码登录场景。
 *
 * `oldSceneKey` 是本标签页上一张还挂在屏幕上的码（过期重建、被取消后重建、切走又切回）。
 * 带回去让服务端把它作废，否则会出现「手机上确认成功、PC 端永远不动」：那张码对应的场景
 * 早就没人轮询了，确认签出的令牌躺在库里等 24 小时被清理任务删掉。
 */
export async function createScanLoginScene(
  oldSceneKey?: string,
): Promise<{ sceneKey: string; expireAt: string }> {
  return await post<{ sceneKey: string; expireAt: string }>(
    '/auth/scan-login/create',
    oldSceneKey ? { oldSceneKey } : undefined,
  );
}

export async function pollScanLoginScene(sceneKey: string): Promise<ScanLoginPollResult> {
  return await get<ScanLoginPollResult>(`/auth/scan-login/poll/${sceneKey}`);
}
